export enum WidgetDataTypeEnum {
  CAREGIVER_UNIT_TYPES = 'CaregiverUnitTypes',
  CARE_SERVICE_TYPES = 'CareServiceTypes',
  SYMPTOMS = 'Symptoms',
}
